module.exports = __webpack_public_path__ + "static/media/logo-invision.4731441a.svg";